/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type HoverState = "card" | "alert" | "none";

export interface InlineCardState {
  alert:
    | {
        id: number;
        /**
         * The index in the overlay position that initiated this
         */
        positionIndex: number;
      }
    | undefined;
  isHovering: boolean;
  hoverState: HoverState;
}

const initialState: InlineCardState = {
  alert: undefined,
  isHovering: false,
  hoverState: "none",
};

export const inlineCardSlice = createSlice({
  name: "InlineCard",
  initialState,
  reducers: {
    attachAlert(
      state,
      action: PayloadAction<{
        alert: { id: number; positionIndex: number } | undefined;
      }>
    ) {
      state.alert = action.payload.alert;
    },
    hover(state, action: PayloadAction<"start" | "stop">) {
      state.isHovering = action.payload === "start";
    },
  },
});

export const { attachAlert, hover } = inlineCardSlice.actions;

export default inlineCardSlice.reducer;
